import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '@/static/icons/arrow_left_icon.svg'
import _imports_1 from '@/static/icons/trash_icon.svg'


const _hoisted_1 = { class: "decoration-bottom-menu" }
const _hoisted_2 = {
  key: 0,
  class: "decoration-bottom-menu__decoration-info"
}
const _hoisted_3 = { class: "decoration-bottom-menu__question" }
const _hoisted_4 = { class: "decoration-bottom-menu__tip" }
const _hoisted_5 = { class: "decoration-bottom-menu__buttons" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "decoration-bottom-menu__file-info"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 2,
  class: "decoration-bottom-menu__summary-remove"
}
const _hoisted_10 = { class: "decoration-remove__modal" }
const _hoisted_11 = { class: "decoration-remove__modal-title" }
const _hoisted_12 = { class: "decoration-remove__modal-subtitle" }
const _hoisted_13 = { class: "decoration-remove__modal-options" }

import { computed, inject, ref, watch } from 'vue';
import { configuratorStateKey } from '../ProductConfiguratorKeys';
import ModalContainer from "@/components/ModalContainer.vue";
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import ErrorMessage from '../../forms/ErrorMessage.vue';
import ConfiguratorChevron from '../ConfiguratorChevron.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DecorationBottomMenu',
  emits: ['goToStep', 'save', 'remove'],
  setup(__props, { emit: __emit }) {

const { configuratorState } = inject(configuratorStateKey);
const registerModal = inject('registerModal');
const unregisterModal = inject('unregisterModal');
const { websiteText } = useWebsiteTexts();
const emit = __emit;

const showWidthHeightError = ref(false);

const saveButtonText = computed(() => {
  return configuratorState.value.decorationSteps.confirmDecoration ? 'global__save' : 'global__next';
});

const placementAndTechniqueSelected = computed(() => {
  return !!(configuratorState.value.selections.selectedPlacement
    && configuratorState.value.selections.selectedTechnique);
});

const desiredWidth = computed(() => {
  return configuratorState.value.selections.desiredWidth || 0;
});

watch(desiredWidth, () => {
  showWidthHeightError.value = false;
});

const desiredHeight = computed(() => {
  return configuratorState.value.selections.desiredHeight || 0;
});

watch(desiredHeight, () => {
  showWidthHeightError.value = false;
});

const selectedTechnique = computed(() => {
  return configuratorState.value.selections.selectedTechnique;
});

watch(selectedTechnique, () => {
  showWidthHeightError.value = false;
});

const editUploadedFile = computed(() => (configuratorState.value.selections.fileUpload
  ? 'confirmDecoration'
  : 'uploadDecoration'));

const confirmationModalOpen = ref(false);

function openConfirmationModal() {
  registerModal('DecoratorRemove');
  confirmationModalOpen.value = true;
}

function closeConfirmationModal() {
  confirmationModalOpen.value = false;
  unregisterModal('DecoratorRemove');
}

function acceptConfirmation() {
  closeConfirmationModal();
  emit('remove');
}

function goToStepAndScrollToView() {
  if ((desiredWidth.value !== 0 && desiredHeight.value === 0) || (desiredWidth.value === 0 && desiredHeight.value !== 0)) {
    showWidthHeightError.value = true;
    return;
  }

  emit('goToStep', editUploadedFile.value);

  const configEl = document.getElementById('decoration-anchor');
  if (!configEl) return;

  const headerOffsetWithExtraPadding = 100;
  setTimeout(() => {
    window.scrollTo({
      top: configEl.offsetTop - headerOffsetWithExtraPadding,
      left: 0,
      behavior: 'smooth',
    });
  }, 300);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(configuratorState).decorationSteps.placeDecoration
        || _unref(configuratorState).decorationSteps.pickTechnique)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(configuratorState).decorationSteps.placeDecoration)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(websiteText)('decoration__decorate_placement_question').value), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(websiteText)('decoration__decorate_placement_tip').value), 1)
              ], 64))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "decoration-bottom-menu__back-button",
              onClick: openConfirmationModal
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                class: "decoration-bottom-menu__back-button-arrow",
                src: _imports_0
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_unref(websiteText)('global__back').value), 1)
            ]),
            _createElementVNode("button", {
              class: "decoration-bottom-menu__continue-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goToStepAndScrollToView())),
              disabled: !placementAndTechniqueSelected.value
            }, [
              _createTextVNode(_toDisplayString(_unref(websiteText)('global__next').value) + " ", 1),
              _createVNode(ConfiguratorChevron, {
                open: true,
                class: "decoration-bottom-menu__continue-button-chevron"
              })
            ], 8, _hoisted_6)
          ]),
          (showWidthHeightError.value)
            ? (_openBlock(), _createBlock(ErrorMessage, {
                key: 1,
                message: _unref(websiteText)('decoration__input_both_size').value
              }, null, 8, ["message"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(configuratorState).decorationSteps.uploadDecoration
        || _unref(configuratorState).decorationSteps.confirmDecoration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "decoration-bottom-menu__back-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('goToStep', 'pickTechnique')))
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("img", {
              class: "decoration-bottom-menu__back-button-arrow",
              src: _imports_0
            }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_unref(websiteText)('global__back').value), 1)
          ]),
          _createElementVNode("button", {
            class: "decoration-bottom-menu__save-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('save'))),
            disabled: !_unref(configuratorState).decorationSteps.confirmDecoration
          }, [
            _createTextVNode(_toDisplayString(_unref(websiteText)(saveButtonText.value).value) + " ", 1),
            (_unref(configuratorState).decorationSteps.uploadDecoration)
              ? (_openBlock(), _createBlock(ConfiguratorChevron, {
                  key: 0,
                  open: true,
                  class: "decoration-bottom-menu__save-button-chevron"
                }))
              : _createCommentVNode("", true)
          ], 8, _hoisted_8)
        ]))
      : _createCommentVNode("", true),
    (_unref(configuratorState).decorationSteps.decorationSummary)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "decoration-bottom-menu__remove-button",
            onClick: openConfirmationModal
          }, [
            _cache[5] || (_cache[5] = _createElementVNode("img", {
              class: "decoration-bottom-menu__remove-button-icon",
              src: _imports_1
            }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_unref(websiteText)('decoration__remove').value), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (confirmationModalOpen.value)
      ? (_openBlock(), _createBlock(ModalContainer, {
          key: 3,
          "show-exit-button": true,
          position: "center",
          onCloseModal: closeConfirmationModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(websiteText)('decoration__remove_title').value), 1),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(websiteText)('decoration__remove_subtitle').value), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  class: "decoration-remove__modal-cancel secondary-button",
                  onClick: closeConfirmationModal
                }, _toDisplayString(_unref(websiteText)('decoration__remove_cancel').value), 1),
                _createElementVNode("button", {
                  class: "decoration-remove__modal-accept primary-button",
                  onClick: acceptConfirmation
                }, _toDisplayString(_unref(websiteText)('decoration__remove_accept').value), 1)
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})